<!-- 
<div class="d-flex justify-content-end">
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox" id="toggleSeqNum" [(ngModel)]="showSeqNum">
    <label class="form-check-label" for="inlineCheckbox1">Show Seq No</label>
  </div>
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox" id="toggleSentDate" [(ngModel)]="showSentDate">
    <label class="form-check-label" for="inlineCheckbox2">Show Sent Date</label>
  </div>
</div>
 -->
<!-- https://codepen.io/bseth99/pen/ZEMrbP -->


<div class="container d-flex justify-content-end">
  <div class="row">
    <div class="col-lg-12">
      <div class="btn-group">
        <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          <span class="bi bi-gear"></span> 
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li>&nbsp;<input type="checkbox" [(ngModel)]="showSeqNum"/>&nbsp;Show Seq No</li>
          <li>&nbsp;<input type="checkbox" [(ngModel)]="showSentDate"/>&nbsp;Show Sent Date</li>
        </ul>
      </div>
    </div>
  </div>
</div>


<br/>

<div class="table-scrollable">

  <table class="table table-hover table-sm table-bordered table-striped table-success">
    <thead class="table-dark text-center">
      <tr>
        @if(showSeqNum){
          <th scope="col">Seq No</th>
        }
        @if(showSentDate){
          <th scope="col">Sent Date</th>
        }
        <th scope="col">Message Text</th>
      </tr>
    </thead>
    <tbody>
      @for (data of notificationHistory; track data; let i = $index) {
        <tr>
          @if(showSeqNum){
            <td scope="col">{{data.messageSeqNum}}</td>
          }
          @if(showSentDate){
            <td>{{data.createDate}}</td>
          }
          <td class="wrap-text">{{data.messageText}}</td>
        </tr>
      }
    </tbody>
  </table>

</div>


<div class="row">
  <div class="col-6 text-center">
    <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="onClose()" label="Close">Cancel</button>
  </div>
</div>                
